module.exports = {
	"library.navbar.sign_up": "Registrer deg",
	"library.navbar.sign_in": "Logg inn",
	"library.navbar.sign_out": "Logg ut",
	"library.navbar.help": "Hjelp",
	"library.navbar.search_for_events": "Søk etter arrangement",
	"library.navbar.enter_location": "Skriv inn lokasjon",
	"library.navbar.find_events": "Finn arrangemen",
	"library.navbar.create_event": "Opprett arrangement",
	"library.navbar.host_events": "Arrangér",
	"library.navbar.dashboard": "Dashboard",
	"library.navbar.my_events": "Arrangement du er vert for",
	"library.navbar.my_tickets": "Din billett",
	"library.navbar.admin_panel": "Adminpanel",
	"library.navbar.profile": "Profil",
	"library.navbar.messages": "Meldinger",
	"library.navbar.settings": "Innstillinger",
	"library.navbar.search_cities": "Søk byer",
	"library.navbar.help_center": "Hjelpesenter",
	"library.navbar.cant_find_tickets": "Where are my tickets?",
	"library.navbar.contact_organizer": "Contact the event organizer",
	"library.navbar.can_refund": "Kan jeg få refusjon?"
};


//////////////////
// WEBPACK FOOTER
// ./~/@uniiverse/library/components/navbar/translations/nb.json
// module id = 1516
// module chunks = 0 1 2 3 4 5 6 7 8 9 10 11 12 13 14 15 16